var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpIco1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emp-ico-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.248,
    height: 13.248,
    viewBox: "0 0 13.248 13.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M0,0H13.248V13.248H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M3.5,5.052l.828.828L5.708,4.5",
    transform: "translate(-1.568 -2.016)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M3.5,11.052l.828.828,1.38-1.38",
    transform: "translate(-1.568 -4.704)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M3.5,17.052l.828.828,1.38-1.38",
    transform: "translate(-1.568 -7.392)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M11,6h4.968",
    transform: "translate(-4.928 -2.688)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M11,12h4.968",
    transform: "translate(-4.928 -5.376)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M11,18h4.968",
    transform: "translate(-4.928 -8.064)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpIco1);
export default __webpack_public_path__ + "static/media/emp-ico-1.3ca6daf4e921466c90cecb0990e4895d.svg";
export { ForwardRef as ReactComponent };